// React
import { useEffect } from "react";
// React Router
import { Route, Routes } from "react-router-dom";
// Pages
import { Home } from "@App/Pages/Partner/VehiClever/Home";
import { Garages } from "@App/Pages/Common/Garages";
import { Profile } from "@App/Pages/Common/Profile";
import { Contact } from "@App/Pages/Common/Contact";
import { Layout } from "@App/Pages/Partner/VehiClever/Layout";
import { Summary } from "@App/Pages/Common/Summary";
import { useDispatch, useSelector } from "react-redux";
import { actionCreators, State } from "@App/state";
import i18n from "@App/utils/i18n";
import { useNavigateWithQueryParams } from "@App/hooks/useNavigateWithQueryParams";
import { bindActionCreators } from "@reduxjs/toolkit";

export function VehiClever() {
  const { navigateWithQuery } = useNavigateWithQueryParams();

  const dispatch = useDispatch();
  const { changeBookableFilter } = bindActionCreators(actionCreators, dispatch);

  const organization = useSelector((state: State) => state.orders.organization);
  // change the language and set onlybookable to true
  useEffect(() => {
    i18n.changeLanguage(organization.settings.language);
    changeBookableFilter(true);
  }, []);

  return (
    <Routes>
      <Route path={"/"} element={<Layout />}>
        <Route
          index={true}
          element={<Home onSubmit={() => navigateWithQuery(`werkstaetten`, true)} />}
        />
        <Route
          path={"/werkstaetten"}
          element={<Garages onSubmit={() => navigateWithQuery(`../werkstatt`, true)} />}
        />
        <Route
          path={"/werkstatt"}
          element={<Profile onSubmit={() => navigateWithQuery(`buchen`, true)} />}
        />
        <Route
          path={"/werkstatt/buchen"}
          element={<Contact onSubmit={() => navigateWithQuery(`erfolgreich`, true)} />}
        />
        <Route path={"/werkstatt/buchen/erfolgreich"} element={<Summary />} />
        <Route
          path={"*"}
          element={<Home onSubmit={() => navigateWithQuery(`werkstaetten`, true)} />}
        />
      </Route>
    </Routes>
  );
}
